import 'css-chunksrc/client/scenes/projectElementDetailsConfiguration/styles.scss';export default {
  "projectElementDetailsConfiguration": "_projectElementDetailsConfiguration_1pyr6_1",
  "main": "_main_1pyr6_8",
  "tabs": "_tabs_1pyr6_14",
  "tab": "_tab_1pyr6_14",
  "selectedTab": "_selectedTab_1pyr6_34",
  "label": "_label_1pyr6_41",
  "footer": "_footer_1pyr6_48",
  "button": "_button_1pyr6_63"
};